<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1">
      <a-page-header
        :ghost="false"
        sub-title="Страница"
        @back="() => $router.go(-1)"
      >
        <template slot="extra" />
        <a-row
          :class="{ 'form-group--error': emptyTitle }"
          align="middle"
          class="flex-baseline"
          style="margin: 0 0 30px 0"
        >
          <a-textarea
            v-model="form.title[langTab]"
            :auto-size="{ minRows: 1, maxRows: 10 }"
            placeholder="Введите заголовок"
            size="small"
            class="ant-page-header-heading-title"
            @input="hotGenerateSlug($event, form, langTab, 'post', 'news')"
          />
          <div v-if="isTitleNull" class="error-text">
            Введите заголовок на одном из языков.
          </div>
        </a-row>
        <!-- <a-textarea
          v-model="form.title[langTab]"
          class="ant-page-header-heading-title"
          :auto-size="{ minRows: 1, maxRows: 10 }"
          placeholder="Введите заголовок"
          size="small"
          @input="
            $__slugCompute({
              event: $event,
              langTab: langTab,
              type: 'post',
              title: form.title,
              postType: 'news',
            })
          "
        />-->
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="ID">
            {{ form.id || "New" }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.created" label="Создан">
            {{ moment(form.created).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.updated" label="Обновлен">
            {{ moment(form.updated).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="form.views" label="Просмотры">
            {{ form.views }}
          </a-descriptions-item>
          <a-descriptions-item label="Опубликован">
            <a-switch v-model="form.status" />
          </a-descriptions-item>
          <a-descriptions-item :label="`Доступность на языке ${langTab}`">
            <a-switch v-model="form.language_support[langTab]" />
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
      <a-tabs :key="$route.fullPath" type="card" @change="tabPaneChangeHandler">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- title -->
          <!-- <a-row
            :class="{ 'form-group--error': emptyTitle }"
            align="middle"
            class="flex-baseline"
          >
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Заголовок:
            </a-col>
            <a-col
              :span="12"
              class="sm-mb"
            >
              <a-input
                v-model="form.title[langTab]"
                placeholder="Введите заголовок"

                @input="$__slugCompute({event: $event, langTab: langTab, type: 'post', title: form.title, postType: 'news'})"
              />
              <div
                v-if="isTitleNull"
                class="error-text"
              >
                Введите заголовок на одном из языков.
              </div>
            </a-col>
          </a-row>-->

          <!-- slug -->
          <a-row
            :class="[
              'flex-baseline',
              { 'form-group--error': $v.form.slug.$error }
            ]"
            align="middle"
          >
            <a-col :span="4" style="text-align: right; padding-right: 8px">
              ЧПУ:
            </a-col>
            <a-col :span="18" class="sm-mb">
              <a-row align="middle" type="flex">
                <span
                  class="mr-1 link"
                  @click="
                    copySlugToBuffer(`/${$options.slugPrefix}/${form.slug}`)
                  "
                >
                  <a-icon :style="{ fontSize: '22px' }" type="copy" />
                </span>

                <span class="flex-1">
                  <a-col :span="18">
                    <a-input
                      id="slug-input"
                      :value="form.slug"
                      placeholder="Введите человеку понятный урл"
                      @input="onSlugChange"
                    />
                  </a-col>

                  <a-col :span="5">
                    <a-tooltip
                      placement="topLeft"
                      :title="`Генерация ЧПУ на  ${langTab}`"
                    >
                      <a-button
                        :disabled="!form.title[langTab]"
                        class="ml-1"
                        block
                        type="primary"
                        @click="
                          $__slugCompute({
                            event: $event,
                            langTab: langTab,
                            type: 'post',
                            title: form.title,
                            postType: 'news'
                          })
                        "
                      >
                        {{ langTab }}
                        <a-icon type="reload" />
                      </a-button>
                    </a-tooltip>
                  </a-col>
                </span>
              </a-row>
              <div v-if="!form.slug" class="error-text">Введите ЧПУ</div>
              <div
                v-if="errors.slug && current_slug != form.slug"
                class="z-error-text"
              >
                Данный ЧПУ недоступен
              </div>
            </a-col>
          </a-row>
          <!-- <a-row
            :class="{ 'form-group--error': emptyExcerp }"
            align="middle"
            class="flex-baseline"
          >
            <a-col
              :span="4"
              style="text-align: right; padding-right: 8px;"
            >
              Подзаголовок:
            </a-col>
            <a-col
              :span="18"
              class="sm-mb"
            >
              <a-textarea
                v-model="form.excerp[langTab]"
                placeholder="Введите подзаголовок"
                :auto-size="{ minRows: 1, maxRows: 6 }"
              />
              <div
                v-if="isExcerpNull"
                class="error-text"
              >
                Введите подзаголовок на одном из языков.
              </div>
            </a-col>
          </a-row>-->

          <!-- position -->
          <!-- <a-row
            align="middle"
            class="flex-baseline"
          >
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Позиция:
            </a-col>
            <a-col
              :span="12"
              class="sm-mb"
            >
              <a-input
                v-model.number="form.position"

                placeholder="Введите позицию"
              />
              <div
                v-if="!form.position"
                class="error-text"
              >
                Введите позицию.
              </div>
            </a-col>
          </a-row>-->
          <!-- store image modal -->
          <a-modal
            :visible="modalVisible"
            title="Хранилище изображений"
            :closable="false"
            style="max-height: 500px; max-width: 900px"
            width="900px"
          >
            <imageStore
              @pasteHandler="editorInstance.insertContent(arguments[0])"
            />
            <template slot="footer">
              <a-button key="back" @click="modalVisible = false">
                Закрыть
              </a-button>
            </template>
          </a-modal>
          <!-- editor -->
          <a-row
            :class="{ 'form-group--error': emptyContent }"
            align="middle"
            style="margin-top: 25px"
          >
            <a-col :span="24">
              <editor
                :key="'tinymce_' + tabPane"
                v-model="form.content[langTab]"
                :init="{
                  height: 450,
                  plugins: [
                    'advlist preview autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                  storage-btn image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  },

                  external_plugins: {
                    myplugin:
                      '/js/tinymce/plugins/image-align/editor_plugin_img.js'
                  },

                  setup: (editor) => {
                    editor.ui.registry.addButton('storage-btn', {
                      icon: 'non-breaking',
                      tooltip: 'Хранилище изображений',
                      onAction: () => {
                        openStoreModal()
                        editorInstance = editor
                      }
                    })
                  }
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
              <div v-if="isContentNull" class="error-text">
                Введите контент на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- status toggle -->
          <!-- <a-row style="margin-top: 25px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>-->

          <!-- visibity on head page -->
          <!-- <a-row style="margin-top: 25px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Поставить на главную:
            </a-col>
            <a-switch v-model="form.is_main" />
          </a-row>-->

          <!-- view in slider -->
          <!-- <a-row style="margin-top: 25px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Поставить на слайдер:
            </a-col>
            <a-switch v-model="form.to_slider" />
          </a-row>-->

          <!-- language availability -->
          <!-- <a-row style="margin-top: 25px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px;"
            >
              Доступность на языке {{ langTab }}
            </a-col>
            <a-switch v-model="form.language_support[langTab]" />
          </a-row>-->
        </a-tab-pane>

        <!-- photo tab -->
        <a-tab-pane key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения
            </a-col>
            <a-col :span="12">
              <image-upload
                :list="newsPhotos"
                :selected-image="main_image"
                accept="image/jpeg, image/png"
                multiple
                @change="handleImages"
                @drag-update="updateFilesPosition"
                @set-main-image="main_image = arguments[0]"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- video tab  -->
        <a-tab-pane key="video">
          <span slot="tab"> <a-icon type="video-camera" />Видео </span>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Тип загрузки:
              </a-col>
              <a-col :span="12">
                <a-select
                  v-model="video_input.file_type"
                  placeholder="Выберите тип загрузки видео"
                  show-search
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="item in videoUploadTypes"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title[$i18n.locale] }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row
              v-if="video_input.file_type != 1"
              style="margin-bottom: 15px"
            >
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Ссылка на видео:
              </a-col>
              <a-col :span="12">
                <!--                <a-col class="mb-2" v-for="(item, index) in videoUrl">-->
                <!--                  <a-input :placeholder="placeholders.video_url[$i18n.locale]" v-model="item.file"/>-->
                <!--                </a-col>-->

                <a-col class="mb-2">
                  <a-input
                    v-model="video_input.file"
                    :placeholder="placeholders.video_url[$i18n.locale]"
                  />
                </a-col>
              </a-col>
            </a-row>

            <a-row v-else style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Файл с компьютера:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.videoRef.click()">
                  <input
                    ref="videoRef"
                    accept="video/*"
                    hidden
                    type="file"
                    @change="handleVideoInput"
                  />
                  <a-icon type="upload" />Выберите файл
                </a-button>

                <InputFileItem
                  :file="video_file"
                  class="mt-2"
                  @delete="video_file = null"
                />
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <a-tab-pane key="document">
          <span slot="tab"> <a-icon type="file" />Документы </span>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Файл документа:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.documentRef.click()">
                  <input
                    ref="documentRef"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf"
                    hidden
                    type="file"
                    @change="handeDocumentInput"
                  />
                  <a-icon type="upload" />Выберите файл
                </a-button>

                <InputFileItem
                  :file="document_file"
                  class="mt-2"
                  @delete="$refs.documentRef.value = document_file = null"
                />
                <InputFileItem
                  v-for="(doc, index) in newsDocs"
                  :key="index"
                  :file="{ name: doc.file.split('/').pop() }"
                  class="mt-2"
                  link
                  @delete="deleteInputFile(doc)"
                />
                <!--                {{ newsDocs }}-->
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <span v-if="form.id" slot="tabBarExtraContent">
          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить данный новость?"
            @confirm="removeItem"
          >
            <a-button :disabled="pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { cloneDeep } from "lodash"
import Editor from "@tinymce/tinymce-vue"
import InputFileItem from "@/components/utils/input-file-item"
import { required } from "vuelidate/lib/validators"

const pageDefaultFields = () => ({
  title: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  content: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  excerp: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  language_support: {
    uz: false,
    oz: false,
    ru: false,
    en: false,
    tj: false,
    kz: false
  },
  slug: "",
  position: 1,
  status: true,
  is_main: false,
  to_slider: false
})

export default {
  name: "Pages",

  slugPrefix: "pages",

  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    imageStore: () => import("@/components/imageStore/imageStore"),
    editor: Editor,
    InputFileItem
  },

  data: () => ({
    form: { ...pageDefaultFields() },
    // eslint-disable-next-line no-undef
    langTab: $langPrefix,
    tabPane: null,

    loading: false,
    pending: false,
    fileList: [],
    video_input: {
      file_type: 3,
      file: ""
    },

    main_image: null,
    video_file: null,
    document_file: null,
    emptyTitle: false,
    emptyContent: false,
    emptyExcerp: false,
    errors: {
      slug: ""
    },

    modalVisible: false,

    current_slug: ""
  }),

  computed: {
    // titlesCheck() {
    //   return this.$v.form.title.oz.$error ||
    //   this.$v.form.title.uz.$error ||
    //   this.$v.form.title.ru.$error
    //     ? true
    //     : false;
    // },
    // contentCheck() {
    //   return this.$v.form.content.oz.$error ||
    //   this.$v.form.content.uz.$error ||
    //   this.$v.form.content.ru.$error
    //     ? true
    //     : false;
    // },

    isTitleNull() {
      return !!(
        !this.form.title.uz &&
        !this.form.title.oz &&
        !this.form.title.ru &&
        !this.form.title.en
      )
    },
    isContentNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en
      )
    },
    isExcerpNull() {
      return !!(
        !this.form.excerp.uz &&
        !this.form.excerp.oz &&
        !this.form.excerp.ru &&
        !this.form.excerp.en
      )
    },
    newsPhotos() {
      return (
        (this.form &&
          this.form.files &&
          this.form.files.filter((item) => item.file_type == 0)) ||
        []
      )
    },
    newsVideos() {
      return (
        this.newsFiles &&
        this.newsFiles.filter(
          (item) =>
            item.file_type === 1 || item.file_type === 3 || item.file_type === 4
        )
      )
    },

    videoUrl() {
      return (
        this.form &&
        this.form.files &&
        this.form.files
          .filter((item) => item.file_type === 3 || item.file_type === 4)
          .sort((a, b) => new Date(b.updated) - new Date(a.updated))
      )
    },

    newsDocs() {
      return (
        this.form &&
        this.form.files &&
        this.form.files.filter((item) => item.file_type == 2)
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    "form.title": {
      handler(val) {
        try {
          // this.form.language_support[ ru or other lang prefix ] = true if form.title[ lang prefix ] exists or false
          this.$set(
            this.form.language_support,
            this.langTab,
            !!val[this.langTab]
          )
        } catch (error) {
          console.log(error)
        }
      },
      deep: true
    }
  },

  // created() {
  //   this.$set(this, "form", {
  //     ...pageDefaultFields
  //   });
  // },

  mounted() {
    // this.$on("slug-check-result", this.setSlugRes);
    this.$on("update:slug", this.onSlugChange)
  },

  // beforeDestroy() {
  //   // fields empty fix
  //   this.$set(this, "form", { ...pageDefaultFields });
  // },

  validations: {
    form: {
      slug: {
        required
      }
    }
  },
  methods: {
    openStoreModal() {
      this.modalVisible = true
    },
    async removeItem() {
      try {
        const r = await this.$store.dispatch(
          "pages/removeItemAction",
          this.form.id
        )

        if (r) {
          this.$message.success("Страница успешно удалена")
          this.$router.go(-1)
        }
      } catch (err) {
        console.log(err)
      }
    },
    onSlugChange(e) {
      const text = (e.target.value || "")
        .replace(/( )/gi, "-")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\\-]/gi, "")

      this.slugCheck({
        payload: { table: "post", slug: text },
        postType: "news"
      })

      this.form.slug = text
    },
    // setSlugRes(arg) {
    // this.errors.slug = (arg && this.form.slug && this.current_slug === this.form.slug ? "" : "Данный ЧПУ недоступен")
    // },
    check2Null(arg) {
      const r = Object.values(arg).every((item) => !item)

      console.log("check2Null", r)

      return r
    },
    // copySlug() {
    //   this.copyStringToClipboard(`/${ this.$options.name }/${ this.form.slug }`);
    //   this.$message.success("ЧПУ скопирован");
    // },
    handleVideoInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_file = e.target.files[0]
      }

      this.$refs.videoRef.value = null
    },
    tabPaneChangeHandler(arg) {
      // tinymce reload fix, !!! important
      this.tabPane = arg
    },
    editorUpdloadHandler(arg, success, failure) {
      success(`data:${arg.blob().type};base64,${arg.base64()}`)

      failure()
    },
    async fetchData() {
      if (!this.$route.params.id || isNaN(this.$route.params.id)) {
        console.log("Invalid router param")
        return
      }
      this.loading = true
      try {
        const data = await this.$store.dispatch(
          "pages/detail",
          this.$route.params.id
        )
        if (data) {
          // console.log("f", data);
          this.form = {
            ...data,
            title: JSON.parse(data.title),
            content: JSON.parse(data.content),
            language_support: data.language_support || {
              ...pageDefaultFields().language_support
            }
          }

          this.current_slug = this.form.slug

          if (
            this.videoUrl &&
            this.videoUrl.length &&
            this.videoUrl[0] &&
            this.videoUrl[0].file
          ) {
            this.video_input = this.videoUrl[0]
          }
        }
      } catch (err) {
        console.error(err)
        this.loading = false
      }
      this.loading = false
    },

    handleImages(arg) {
      this.fileList = arg || []
    },

    updateFilesPosition() {
      let promises = []
      let otherImages = new FormData()
      const mainImage = this.fileList.find(
        (item) => item.id && item.uzid === this.main_image
      )

      if (mainImage) {
        otherImages.append("is_main", true)
        otherImages.append("file_type", 0)
        otherImages.append("position", 0)
        otherImages.append("file", mainImage.file || mainImage.fileTarget)
        promises.push(
          this.$api.put("/news/file/update/" + mainImage.id, otherImages)
        )
      }

      console.log(+!!mainImage)

      // debugger;

      Array.from(this.fileList)
        .filter((item) => item.id && item.uzid !== this.main_image)
        .map((item, index) => {
          otherImages = new FormData()

          otherImages.append("is_main", false)
          otherImages.append("position", index + +!!mainImage)
          otherImages.append("file_type", 0)
          otherImages.append("file", item.file || item.fileTarget)

          promises.push(
            this.$api.put("/news/file/update/" + item.id, otherImages)
          )
        })

      Promise.all(promises)
        .then(
          (res) => {
            console.log(res)
          },
          (err) => {
            console.log(err)
          }
        )
        .then((res) => {
          console.log(res)
          this.$message.success("Позиции успешно сохранены")
        })
    },

    handeDocumentInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.document_file = e.target.files[0]
      }
    },
    async submit() {
      console.log("submit!")
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      if (this.check2Null(this.form.title)) {
        this.emptyTitle = true
        return
      }
      if (this.check2Null(this.form.content)) {
        this.emptyContent = true
        return
      }
      //  if (this.check2Null(this.form.excerp)) {
      //   this.emptyExcerp = true;
      //   this.$message.error("Введите подзаголовок на одном из языков");
      //   return;
      // }

      if (this.errors.slug && this.current_slug != this.form.slug) {
        this.$message.error("ЧПУ занят, введите другое")
        return
      }

      // do your submit logic here
      this.pending = true
      let newData = cloneDeep(this.form)

      newData = {
        ...newData,
        title: JSON.stringify(newData.title),
        content: JSON.stringify(newData.content),
        excerp: JSON.stringify(newData.excerp),
        static: true
      }

      const createOrUpdate = {
        url:
          this.form && this.form.id
            ? "/news/post/update/" + this.form.id
            : "/news/post/page/create",
        method: this.form && this.form.id ? "put" : "post",
        data: newData
      }

      // console.log("submit pre data", createOrUpdate);

      try {
        const res = await this.$api[createOrUpdate.method](
          createOrUpdate.url,
          createOrUpdate.data,
          { timeout: 0 }
        )

        if (res && res.status >= 200 && res.data && res.data.id) {
          if (res.data.id) {
            // eslint-disable-next-line no-unused-vars
            const { created, id } = res.data

            this.$set(this, "form", { ...this.form, id })

            // upload after post done
            this.uploadPostFiles()
          }
        }

        this.pending = false
      } catch (err) {
        console.log(err)
        this.pending = false
      }
      this.pending = false
    },

    uploadPostFiles() {
      this.pending = true

      let promises = []

      // upload images
      Array.from(this.fileList).map((item, index) => {
        let img = new FormData()

        const req = {
          attr: "create",
          id: this.form.id,
          method: "post"
        }

        if (item.id) {
          req.attr = "update/" + item.id
          req.id = item.id
          req.method = "put"
          img.append("file", item.file)
        } else {
          img.append("file", item.fileTarget)
        }
        img.append("is_main", this.main_image == item.uzid)
        img.append("news_id", this.form.id)
        img.append("file_type", 0)
        img.append("status", true)
        img.append(
          "position",
          this.main_image == item.uzid ? 0 : index == 0 ? 1 : index
        )

        promises.push(this.$api[req.method](`/news/file/${req.attr}`, img))
      })

      // upload video
      if (this.video_input.file && this.form.id) {
        const f = new FormData()
        let req = {
          url: "create",
          method: "post"
        }

        f.append(
          "file",
          this.video_input.file_type == 1
            ? this.video_file
            : this.video_input.file
        )
        f.append("file_type", this.video_input.file_type)
        f.append("news_id", this.form.id)
        f.append("status", true)
        f.append("is_main", true)
        f.append("position", 1)

        if (this.video_input.id) {
          req = {
            url: "update/" + this.video_input.id,
            method: "put"
          }
        }

        promises.push(this.$api[req.method]("/news/file/" + req.url, f))
      }

      // upload docs
      if (this.document_file) {
        const f = new FormData()
        f.append("file", this.document_file)
        f.append("news_id", this.form.id)
        f.append("file_type", 2)
        f.append("status", true)
        f.append("is_main", true)
        f.append("position", 1)
        promises.push(this.$api.post("/news/file/create", f))
      }

      Promise.all(promises)
        .then(
          () => {
            // console.log(res);
          },
          () => {
            // console.log(err);
          }
        )
        .then(() => {
          this.pending = false
          this.$message.success("Новость успешно сохранено")
          this.$router.go(-1)
        })
        .catch(() => (this.pending = false))
    },

    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }

        if (this.form.content[from]) {
          this.form.content[to] = this[methodName](this.form.content[from])
        }

        if (this.form.excerp[from]) {
          this.form.excerp[to] = this[methodName](this.form.excerp[from])
        }

        // turn on translit target language_support
        this.$set(this.form.language_support, to, true)
      } catch (error) {
        console.log("translitAction error", error)
      }
    },

    async deleteInputFile(arg) {
      try {
        const res = await this.$store.dispatch("file/delete", arg.id)

        if (res && this.form && this.form.files && this.form.files.length) {
          const f = this.form.files.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.form.files.splice(f, 1)
            this.$message.success("Файл успешно удален")
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
